// import he from "he";

const BASE_URL = "https://pms.api.algosu.com";
const S3_BASE_URL = "https://pms-project-s3.s3.ap-south-1.amazonaws.com";

// Caching
// let cachedPageSections = null;
// let sectionFetchPromise = null;

const fetchData = async (endpoint, method = "GET", body = null) => {
  try {
    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, options);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return null;
  }
};

const getBanners = async () => {
  try {
    const { data } = await fetchData("/api/v1/banner");
    if (!data) return [];

    return {
      ...data,
      bannerImage: data.bannerImage ? `${S3_BASE_URL}/${data.bannerImage}` : "",
    };
  } catch (error) {
    console.error("Failed to fetch banners:", error);
    return [];
  }
};

export { fetchData, getBanners, BASE_URL, S3_BASE_URL };
